import { render, staticRenderFns } from "./OrderDetailsModal.vue?vue&type=template&id=5fe72d26&scoped=true"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsModal.vue?vue&type=style&index=0&id=5fe72d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe72d26",
  null
  
)

export default component.exports